<template>
  <div>
    <div class="other-banner">
      <div class="w-default center">
        <ul class="crumb">
          <li>首页</li>
          <li>智慧文博解决方案</li>
        </ul>
        <h1>智慧文博解决方案</h1>
      </div>
    </div>
    <div class="introduction-row">
      <div class="w-default d-flex flex-colum ai-center">
        <h2>智慧文博解决方案</h2>
        <p>在文博行业，安信提供线上展示平台、虚拟展馆、预约服务、藏品管理系统、大数据服务系统、客流分析系统等多个软件产品，提供包含互联网服务、现场服务、智慧管理、大数据服务在内的全套智慧文博解决方案。</p>
        <!-- <button></button> -->
      </div>
    </div>
    <div class="article-row w-default" id="article">
      <aside>
        <ul class="items-1">
          <li :class="[isActive1==1?'active':'','show']">
            <h2 @click="show($event)">互联网服务</h2>
            <ul class="items-2">
              <li :class="[isActive2=='1-1'?'active':'']" @click.stop="active('1-1')">线上展示服务</li>
              <li :class="[isActive2=='1-2'?'active':'']" @click.stop="active('1-2')">虚拟展馆</li>
              <li :class="[isActive2=='1-3'?'active':'']" @click.stop="active('1-3')">预约服务</li>
            </ul>
          </li>
          <li :class="[isActive1==2?'active':'','show']">
            <h2 @click="show($event)">现场服务</h2>
            <ul class="items-2">
              <li :class="[isActive2=='2-1'?'active':'']" @click.stop="active('2-1')">客流管理系统</li>
              <li :class="[isActive2=='2-2'?'active':'']" @click.stop="active('2-2')">触摸屏导览系统</li>
              <li :class="[isActive2=='2-3'?'active':'']" @click.stop="active('2-3')">移动导览系统</li>
              <li :class="[isActive2=='2-4'?'active':'']" @click.stop="active('2-4')">团队导览系统</li>
              <li :class="[isActive2=='2-5'?'active':'']" @click.stop="active('2-5')">无线定位系统</li>
              <li :class="[isActive2=='2-6'?'active':'']" @click.stop="active('2-6')">互动展厅</li>
              <li :class="[isActive2=='2-7'?'active':'']" @click.stop="active('2-7')">多媒体信息发布与控制</li>
              <li :class="[isActive2=='2-8'?'active':'']" @click.stop="active('2-8')">统一运行管理平台</li>
            </ul>
          </li>
          <li :class="[isActive1==3?'active':'','show']">
            <h2 @click="show($event)">智慧管理</h2>
            <ul class="items-2">
              <li :class="[isActive2=='3-1'?'active':'']" @click.stop="active('3-1')">藏品综合管理系统</li>
              <li :class="[isActive2=='3-2'?'active':'']" @click.stop="active('3-2')">综合办公系统</li>
              <li :class="[isActive2=='3-3'?'active':'']" @click.stop="active('3-3')">业务集成平台</li>
              <li :class="[isActive2=='3-4'?'active':'']" @click.stop="active('3-4')">藏品数字化管理</li>
              <li :class="[isActive2=='3-5'?'active':'']" @click.stop="active('3-5')">非物质文化遗产管理系统</li>
              <li :class="[isActive2=='3-6'?'active':'']" @click.stop="active('3-6')">文物修复保护管理系统</li>
              <li :class="[isActive2=='3-7'?'active':'']" @click.stop="active('3-7')">展览管理系统</li>
              <li :class="[isActive2=='3-8'?'active':'']" @click.stop="active('3-8')">教育管理系统</li>
              <li :class="[isActive2=='3-9'?'active':'']" @click.stop="active('3-9')">物业管理系统</li>
              <li :class="[isActive2=='3-10'?'active':'']" @click.stop="active('3-10')">数字化观众管理系统</li>
            </ul>
          </li>
          <li :class="[isActive1==4?'active':'','show']">
            <h2 @click="show($event)">大数据服务平台</h2>
            <ul class="items-2">
              <li :class="[isActive2=='4-1'?'active':'']" @click.stop="active('4-1')" :data-to="article">大数据平台</li>
            </ul>
          </li>
        </ul>
      </aside>
      <article v-show="isActive2=='1-1'">
        <h1 class="mb-30">线上展示平台</h1>
        <p
          class="mb-40"
        >为公众提供网站、APP、微信公众平台、小程序等服务窗口，用户可以通过电脑、手机、平板、一体机等多种终端设备获得由博物馆提供的服务，包含如身临其境般畅游虚拟展馆、便捷浏览高清三维文物服务，基于室内、室外定位技术的馆内外线路推荐服务，富媒体消息推送服务。</p>
        <img class="mb-60 w-100" src="../assets/img/SolutionMuseum/eg-1.jpg" alt />
        <h2 class="mb-20">系统特点</h2>
        <h3>1）多个服务窗口</h3>
        <P>提供网站、APP、微信公众平台、小程序等多个服务窗口。</P>
        <h3>2）支持多种终端</h3>
        <P>支持电脑、手机、平板、一体机等多种终端。</P>
        <h3>3）丰富的展示方式</h3>
        <P>支持文字图片、3D模型、音频、视频、动画、VR等形式。</P>
        <h3>4）多国语言支持</h3>
        <P>初始设置中文/繁体版、英文版，支持便捷的语言扩展。</P>
        <h3>5）智能的服务</h3>
        <p>提供语音导览、移动导览、在线预约个性化推荐等多种服务。</p>
      </article>
      <article v-show="isActive2=='1-2'">
        <h1 class="mb-30">虚拟展馆</h1>
        <p
          class="mb-40"
        >采用三维虚拟现实、实物3d重建、3d展示、移动互联网等技术，对展馆同名展览内容进行全方位的数字化呈现，使观众足不出户可以畅游展馆，查看三维藏品，同时提供展览、藏品的文字、音频、视频等方式的介绍，以及留言、评论、分享等功能。</p>
        <img class="mb-60 w-100" src="../assets/img/SolutionMuseum/eg-2.jpg" alt />
      </article>
      <article v-show="isActive2=='1-3'">
        <h1 class="mb-30">预约服务</h1>
        <p
          class="mb-40"
        >观众通过网站、微信、APP等窗口了解展馆信息，同时可进行相关预约，预约服务节省观众排队等待时间，同时展馆也可提前做好接待工作。包含票务预约、讲解预约、活动预约等功能。</p>
        <img class="mb-60 m-auto" src="../assets/img/SolutionMuseum/eg-3.jpg" alt />
        <h2 class="mb-20">系统特点</h2>
        <h3>1）支持可视化预约服务</h3>
        <P>观众可在日历图中直观的看到预约情况，点击相应的日期既可快捷进行预约。</P>
        <h3>2）支持验票功能</h3>
        <P>提供二维码图片，观众凭借二维码验票入馆，支持通过刷身份证的方式验票入馆。</P>
        <h3>3）智能规则设置</h3>
        <P>团队预约提供预约模板，观众下载模板后填写相关信息，上传后即可完成预约。</P>
        <h3>4）支持团队预约</h3>
        <P>支持自动按展馆馆开放展览规则开放预约日期及参观人数。</P>
        <h3>5）支持短息提醒</h3>
        <P>当临时闭馆时，支持一键为预约观众发送消息提醒。</P>
      </article>
      <article v-show="isActive2=='2-1'">
        <h1 class="mb-30">客流管理系统</h1>
        <p class="mb-40">采用物联网技术对参观客流进行实时的采集、处理、分析，并根据需要进行信息的发布，提升展览场地的指挥和疏导效果。</p>
        <img class="mb-60 m-auto" src="../assets/img/SolutionMuseum/eg-4.jpg" alt />
        <h2 class="mb-20">系统特点</h2>
        <P>1）统计量准确，适合在人流拥挤、现场人和物体复杂的场合，统计准确率在95%以上。</P>
        <P>2）不易察觉性，记录客流不会对观众产生行为干扰。</P>
        <P>3）施工简便，不影像展厅美观。</P>
        <P>4）功能强大，可统计双向人流与人群保有量。</P>
        <P>5）提供标准接口，并于定制统计分析。</P>
        <P>6）支持实时客流监控、客流统计分析、展厅统计分析，人员拥挤预警等功能。</P>
      </article>
      <article v-show="isActive2=='2-2'">
        <h1 class="mb-30">触摸屏导览系统</h1>
        <p
          class="mb-40"
        >系统主要包括中央控制、维护系统。分为总体概览和分区细览。利用计算机数字化设备和技术手段为观众提供展览馆介绍、文物藏品概览、参观路线指引、展览信息公告、专题影像播放、天气预报周报、文化设施等公共信息等功能。</p>
        <p class="mb-40">在大厅、展厅门口、观众休息处等设置的触摸屏导览终端。透过丰富多变的影像，让观众在轻松愉悦的气氛下，了解展馆馆的环境资源及各种活动内容和服务。</p>
        <img class="mb-60 m-auto" src="../assets/img/SolutionMuseum/eg-5.jpg" alt />
      </article>
      <article v-show="isActive2=='2-3'">
        <h1 class="mb-30">移动导览系统</h1>
        <p class="mb-40">观众通过专业的导览终端、手机（APP\微信）等终端参观展馆，实现多种导览功能，提升用户的参观体验。</p>
        <img class="mb-60 m-auto" src="../assets/img/SolutionMuseum/eg-6.jpg" alt />
        <h2 class="mb-20">系统特点</h2>
        <h3>1）丰富的导览讲解服务</h3>
        <P>支持图文讲解、语音讲解、展品知识拓展、动画视频讲解、三维文物展示、VR展示等功能。</P>
        <h3>2）定位服务</h3>
        <P>支持周边文物自动讲解、路线推荐、精品游、快速参观等功能。</P>
        <h3>3）信息推送</h3>
        <P>支持富媒体信息推送。</P>
        <h3>4）互动交流</h3>
        <P>支持留言、投票、分享墙、问卷、互动竞答等功能。</P>
      </article>
      <article v-show="isActive2=='2-4'">
        <h1 class="mb-30">团队导览系统</h1>
        <p class="mb-40">基于各团队的规模和性质，提供分区讲解、独立讲解、同声传译讲解，从团队预约到讲解员调度到现场管理，提供全方位服务。</p>
        <h2 class>【团队智慧讲解系统】</h2>
        <p class="mb-30">大型学生团队、社会团队、政务接待等使用团队讲解系统，观众无需佩戴任何设备，轻松收听，便于管理。</p>
        <img class="mb-40 m-auto" src="../assets/img/SolutionMuseum/eg-7-01.jpg" alt />
        <h2 class>【无线团队讲解系统】</h2>
        <p class="mb-30">VIP团队、领导团队、小型团体使用无线讲解系统接待，独立收听，互不干扰。</p>
        <img class="mb-60 m-auto" src="../assets/img/SolutionMuseum/eg-8-01.jpg" alt />
      </article>
      <article v-show="isActive2=='2-5'">
        <h1 class="mb-30">无线定位系统</h1>
        <p class="mb-40">提供各类大型复杂场景的三维地图模型制作服务、提供iBeacon、UWB、WiFi、可见光等多种定位技术服务。</p>
        <img class="mb-40 m-auto" width="500" src="../assets/img/SolutionMuseum/eg-9.png" alt />
        <img class="mb-40 m-auto" src="../assets/img/SolutionMuseum/eg-9-01.png" alt />
      </article>
      <article v-show="isActive2=='2-6'">
        <h1 class="mb-30">互动展厅</h1>
        <h2 class>【互动魔墙】</h2>
        <p
          class="mb-30"
        >互动魔墙通过高分辨度及高饱和度的显示技术与高精准的多点触摸屏互动，让观众与藏品“近距离接触”，手指轻轻一动就能放大模型进行观看、旋转、缩放等互动操作。通过扫描二维码可进入到该文物的线上互动展示页面。</p>
        <img class="mb-40 m-auto" width="300" src="../assets/img/SolutionMuseum/eg-10-01.jpg" alt />
        <h2 class>【摄影留念】</h2>
        <p
          class="mb-30"
        >为现场观众提供摄影留念互动服务，观众可以在不同的历史场景中穿上各历史时期的服装进行拍照留念，拍照完成后，游客可以通过直接打印照片，或获取照片的电子版，分享到微信等平台。</p>
        <img class="mb-60 m-auto" width="300" src="../assets/img/SolutionMuseum/eg-11-01.jpg" alt />
        <h2 class>【空气成像】</h2>
        <p
          class="mb-30"
        >通过空气成像技术，将藏品或者信息化图表影像显示在空中，观众伸手可穿透性的触摸到影像，给观众前所未有的视觉体验。同时观众可以和影像进行互动，展示令人震憾的科技效果，动感十足。</p>
        <img class="mb-60 m-auto" width="300" src="../assets/img/SolutionMuseum/eg-12-01.jpg" alt />
        <h2 class>【全息全体成像】</h2>
        <p
          class="mb-30"
        >全息立体成像技术，又称为虚拟成像技术，主要是利用干涉和衍射的原理将物体的三维图像进行再现，是全息摄影技术的逆向展示过程。实现影像与实物的完美结合，非常适合于表现细节或内部结构较丰富的个体物品。新华未来可根据客户要求定制开发。精美细致的外观，宽广舒适的视觉角度，强大无比的全息影像，幻影成像系统将内容全貌大角度全方位的展示给观众，对比度、清晰度，色彩饱和均达到国内同类产品的较高水准。</p>
        <img class="mb-60 m-auto" width="300" src="../assets/img/SolutionMuseum/eg-13-01.jpg" alt />
        <h2 class>【虚拟头盔】</h2>
        <p
          class="mb-30"
        >挑选精品文物，模拟出其出土时的虚拟场景。通过设置两套头戴式虚拟头盔展示两件重点文物出土时的虚拟场景，让游客身临其境的体验到考古发掘的现场，并能根据自己头部的转动而体验不同方位角度的场景，完全像自己置身于文物出土的考古现场。每套头戴式虚拟头盔配置一套投影系统，在体验者戴头盔进行体验时，其他游客也可通过投影画面观看其体验场景画面，一同感受文物出土的虚拟场景。</p>
        <img class="mb-60 m-auto" width="300" src="../assets/img/SolutionMuseum/eg-14-01.jpg" alt />
        <h2 class>【互动体验】</h2>
        <p class="mb-30">通过体感、VR、全息展示等多种形式为观众提供多样化的参观体验，让历史、文物不再是冷冰冰的静物，而是能够进行亲身体验感受的全新模式。</p>
        <img class="mb-60 m-auto" width="300" src="../assets/img/SolutionMuseum/eg-15-01.jpg" alt />
      </article>
      <article v-show="isActive2=='2-7'">
        <h1 class="mb-30">多媒体信息发布与控制</h1>
        <h2 class>【多媒体信息发布】</h2>
        <p
          class="mb-30"
        >系统负责博物馆内一体机、触摸终端等多媒体设备的信息发布和展现。通过导览终端，可供观众自助查询展览馆介绍、场馆分布、展览陈列、馆藏精品、参观路线、服务设施等信息，有文字、图片和音视频等多媒体的交互查询功能。</p>
        <img class="mb-40 m-auto" width="300" src="../assets/img/SolutionMuseum/eg-16-01.jpg" alt />
        <h2 class>【多媒体设备控制】</h2>
        <p class="mb-30">对博物馆内的多媒体设备进行集中管控，包含设备控制、播放控制、设备监控、通过移动终端控制设备等功能。</p>
        <img class="mb-60 m-auto" width="300" src="../assets/img/SolutionMuseum/eg-17-01.jpg" alt />
      </article>
      <article v-show="isActive2=='2-8'">
        <h1 class="mb-30">统一运行管理平台</h1>
        <p
          class="mb-40"
        >统一性能保障平台是为了满足对各类系统运行维护情况的监控需求，将IT基础设施、安防设施以及业务应用系统的运行情况进行一体化的监控，提供更加高效的运行维护监控手段，保障应用系统的稳定、高速运行。系统可对应用系统进行用户体验实时评分，并对系统未来的用户体验做预估分析，提前对可能影响用户体验的因素进行处理，保证应用系统为用户提供高质量的服务。</p>
        <p
          class="mb-40"
        >可视化数据中心系统可放在信息机房或办公入口，可让更多管理人员通过直观的可视化图形数据了解博物馆实时的运行状态，包括展览，展品，观众，环境，活动等各方面，以此作为依据调整博物馆运营和管理。系统借助于图形化手段，将可视化展示与业务需求相结合，有效的传达数据集的思想概念，从不同维度深入观察并提炼数据集关键特征。从而从数据中挖掘出通过传统方式无法发现的信息，让数据产生更大价值。建设“综合”显示数据可视化的综合仪表盘，包括IT设施数据、展览数据、展品数据、藏品数据、观众行为数据、活动数据、客流数据、图书馆数据、媒体数据、教育数据等分析展示。</p>
        <img class="mb-60 m-auto" src="../assets/img/SolutionMuseum/eg-18-01.jpg" alt />
      </article>
      <article v-show="isActive2=='3-1'">
        <h1 class="mb-30">藏品综合管理系统</h1>
        <p
          class="mb-40"
        >系统以藏品为中心，实现藏品的全面信息化管理和利用，使得藏品管理业务流程更加规范，藏品管理利用更加高效安全，旨在全面有效的提升展馆藏品管理的规范性和高效性。系统包含藏品的征集管理、藏品编目、影像管理、藏品保管、库房管理、藏品展览、统计管理、藏品档案和系统管理等功能。</p>

        <img class="mb-60 m-auto" src="../assets/img/SolutionMuseum/eg-19-01.jpg" alt />
        <h2 class="mb-20">系统特点</h2>
        <p>1）支持大数据采集、标注、存储、高速查询</p>
        <p>2）支持藏品全生命周期的管理</p>
        <p>3）支持RFID藏品库房管理</p>
        <p>4）支持移动端管理系统</p>
        <p>5）支持信息智能检索</p>
        <p>6）支持信息智能展示</p>
        <p>7）支持工作量管理</p>
      </article>
      <article v-show="isActive2=='3-2'">
        <h1 class="mb-30">综合办公系统</h1>
        <p
          class="mb-40"
        >以馆内需求为核心，以完善的制度为保障，以最先进技术为手段建设业务标准化、操作个性化、功能全面实用的协同办公系统。通过办公系统建设，实现提升工作效率、规范内部管理、节省办公支出、加快信息传递、增强领导监管能力、加强辅助办公、实现异地办公、时间文档自动化管理等目标，特别是加强公文办理、信息传递、事务督办等能力，实现日常办公管理的规范化、标准化、科学化、高效化。</p>
        <p class="mb-40">包含公文管理、事务督办、领导公务安排、会务管理、考勤管理、公共信息、移动办公、个人办公、后勤保障等功能。</p>

        <img class="mb-60 m-auto" src="../assets/img/SolutionMuseum/eg-20-01.jpg" alt />
      </article>
      <article v-show="isActive2=='3-3'">
        <h1 class="mb-30">业务集成平台</h1>
        <p
          class="mb-40"
        >结合博物馆实际需求，以服务为导向，为博物馆定制业务集成平台。通过业务集成平台，有效实现博物馆各馆各系统之间的信息共享，实现各系统界面融合、业务融合、数据融合，为工作人员、管理人员提供一站式服务平台。</p>
        <p class="mb-40">业务集成平台要求功能完善，操作简便。不仅能够支持PC客户端访问，并且能够支持移动端访问，方便工作人员和管理人员随时随地便捷的办理业务。</p>
        <p class="mb-40">综合业务集成平台主要包含统一门户服务、移动门户服务、统一身份认证、统一消息服务、业务集成管理等功能。</p>

        <img class="mb-60 m-auto" src="../assets/img/SolutionMuseum/eg-21-01.jpg" alt />
      </article>
      <article v-show="isActive2=='3-4'">
        <h1 class="mb-30">藏品数字化管理</h1>
        <img class="mb-40 m-auto" src="../assets/img/SolutionMuseum/eg-22-01.jpg" alt />
        <h2 class>【数字化采集】</h2>
        <p class="mb-30">博物馆数字化资源的采集包括藏品本身的资源采集，以及展示场景或场馆的资源采集。</p>
        <h3>1）文物3D模型采集</h3>
        <P>
          传统文物档案主要由文字、照片、图纸、音视频等资料组成，很难将文物的细节和色彩等更多的信息完整保存下来。三维数字化数据采集和加工是一项基础数据工作。从文物全方位数字化保护的角度出发，要求利用先进的三维数字化技术手段，开展文物、展品的三维数据采集和加工，最终获取“真三维”、“真尺寸”的三维数据。对文物、展品拍摄高清图片，获取文物真实的纹理信息，既是数字化保护的手段之一，也是最终实现“真纹理”三维数据的必备条件。
          <br />利用场景建模与360全景技术，实现对场馆建筑、展厅空间的三维数字化，以及全景拍摄与拼接，为最终形成“真场景”的三维数据提供服务。
        </P>
        <h3>2）文物高清拍摄</h3>
        <p
          class="mb-40"
        >满足高清展示、文创等；覆盖档案级；多幅多角度影像；每幅约60-100M，6000万像素；数据格式为RAW + TIFF + JPG；文物数据录入指定系统：文物信息、图像，命名的信息、拍摄信息数据等</p>
        <h2 class>【数字媒体管理系统】</h2>
        <p
          class="mb-30"
        >数字媒体管理为博物馆建立一套规范的、准确的、先进的数字化内容管理系统，对博物馆在运营、宣传教育、日常办公等活动中产生的大量数据内容，包括出版物、图纸设计、展览活动等图片、音视频、文字等资料、文物采集、展馆采集的三维、高清图片等资源进行管理。同时通过大数据技术应用，提供相似资源归类、智能搜索等功能，为馆方工作人员减负增效。</p>
      </article>
      <article v-show="isActive2=='3-5'">
        <h1 class="mb-30">非物质文化遗产管理系统</h1>
        <p
          class="mb-40"
        >非物质文化遗产管理是提供文档、图像、视频、音频、虚拟三维展示、考古发掘、传统工艺、民俗节庆、少数民族、临时展览、国家文博专题等非物质文化遗产信息的统一集成管理，并提供与藏品系统的接口。</p>
        <img class="mb-60 m-auto" src="../assets/img/SolutionMuseum/eg-23-01.jpg" alt />
      </article>
      <article v-show="isActive2=='3-6'">
        <h1 class="mb-30">文物修复保护管理系统</h1>
        <p
          class="mb-40"
        >该系统的建成将为博物馆文物修复保护部门提供日常主要工作处理，同时为其它部门再利用，研究提供信息支撑系统。系统将提供准确、有效、广泛、及时、可靠、安全的信息服务平台，实现文物修复保护工作现代化、信息资源化、传输网络化，建立一个全新概念的、开放的现代管理和协同工作环境。在功能上，系统实现对文物修复保护项目审批、立项、实施和验收的信息化管理，实现信息的交互共享，成为国内文物修复保护示范应用。</p>
        <img class="mb-60 m-auto" src="../assets/img/SolutionMuseum/eg-24-01.jpg" alt />
      </article>
      <article v-show="isActive2=='3-7'">
        <h1 class="mb-30">展览管理系统</h1>
        <p
          class="mb-40"
        >结合博物馆实际需求，定制展览管理系统，帮助博物馆打通所有业务障碍，实现全面正确决策及展览管理一体化的管理系统。帮助博物馆聚焦客户价值，提升展览策划能力，降低时间和管理成本。</p>
        <img class="mb-60 m-auto" src="../assets/img/SolutionMuseum/eg-25-01.jpg" alt />
        <h2 class>【展览策划管理】</h2>
        <h3>1）申请立项</h3>
        <P>根据展览项目立项管理规定执行立项审批过程，并对每个阶段的资料和信息进行管理维护。包括策展人申请、展览项目可行性研究报告、展览项目经费预算、展览项目申报、组建项目组。</P>
        <h3>2）展览策划</h3>
        <P>展览策划分为展览资料采集、展品集中、展览文案编辑、展览宣传、教育、培训、文创综合方案编制、展览方案评审，展览管理系统要做到按照策划阶段进行管理，并对每个阶段的数据和资料保管。</P>
        <h3>3）展览实施</h3>
        <P>展览实施分为展览项目政府采购、展览形式设计、展览制作、施工及验收、展览布展、展览开放、展览撤展几个阶段，展览管理系统要做到按照策划阶段进行管理，并对每个阶段的数据和资料保管。</P>
        <h3>4）展览审核</h3>
        <P>展览审核分为展览审计与决算、展览评估两个阶段，展览管理系统要做到按照策划阶段进行管理，并对每个阶段的数据和资料保管。</P>
        <h3>5）资料整理</h3>
        <P
          class="mb-40"
        >资料整理分为展览总结、展览资料整理、展览资料建档三个阶段，其中展览资料又包括了文字资料、图片资料、视频资料，展览管理系统要做到按照策划阶段进行管理，并对每个阶段的数据和资料保管。</P>
        <h2 class>【展览服务管理】</h2>
        <h3>1）展厅管理</h3>
        <P>展厅管理包含两部分内容，一部分是对实体展厅的管理，主要是展厅相关的设备进行监控，对临时展厅的使用申请和审批管理；另一部分是关于数字展厅的管理，主要是对数字展厅数字化资源的更新和维护管理。</P>
        <h3>2）展览管理</h3>
        <P>展览管理是对博物馆参与的所有展览的本体、信息、资源等的全面管理，包括基本陈列、临展、合作办展等。</P>
        <h3>3）展览资讯</h3>
        <P>展览资讯管理主要是对与展览有关的资讯信息进行管理和发布，包括新的展讯信息发布，重要展览的推介信息发布，特展信息回顾，行业动态信息发布。同时，需要对合作伙伴的常用联系方式进行集中管理，提供相应的链接。</P>
      </article>
      <article v-show="isActive2=='3-8'">
        <h1 class="mb-30">教育管理系统</h1>
        <p
          class="mb-40"
        >博物馆与城市中小学校建立长期交流和合作机制，促进学校将学生在博物馆的参观和学习纳入学校的课程体系中。该系统包括教育资源管理、宣教老师管理、宣教活动管理等。该系统是通过“互联网+”社教的理念，对博物馆的社会教育资源进行线上线下的整合，建立一体化的博物馆教学活动平台。</p>
        <img class="mb-60 m-auto" src="../assets/img/SolutionMuseum/eg-26-01.jpg" alt />
      </article>
      <article v-show="isActive2=='3-9'">
        <h1 class="mb-30">物业管理系统</h1>
        <p
          class="mb-40"
        >博物馆物业管理系统主要是针对物业公司的服务效果进行管理，不涉及物业公司内部的管理细节，博物馆馆员对物业的服务规范化执行定期和不定期检查工作机制，保障物业服务的有效性。系统除了PC桌面版本，还针对物业行业移动办公多的特性，提供移动应用客户端，提供如移动巡检、报修、接单、等功能。</p>
        <img class="mb-60 m-auto" src="../assets/img/SolutionMuseum/eg-27-01.jpg" alt />
      </article>
      <article v-show="isActive2=='3-10'">
        <h1 class="mb-30">数字化观众管理系统</h1>
        <p
          class="mb-40"
        >数字化观众管理系统结合博物馆在观众服务、观众培育、预防突发事件等方面的实际需求，汇集多源观众属性数据和行为数据，构建观众数字化管理中心，促进线上与线下的服务深度融合，建立观众服务评价体系。</p>
        <img class="mb-60 m-auto" src="../assets/img/SolutionMuseum/eg-28-01.jpg" alt />
      </article>
      <article v-show="isActive2=='4-1'">
        <h1 class="mb-30">大数据服务平台</h1>
        <h2 class="mb-20">主要功能</h2>
        <h3>1）大数据中心</h3>
        <P>海量复杂架构数据的存储、备份。</P>
        <h3>2）数据集成转换</h3>
        <P>数据源管理、数据采集、数据的批量导入、ETL工具、数据处理、质量管理等。</P>
        <h3>3）数据智能分析</h3>
        <P>数据关联关系建立、自动分类、图片及文件识别、数据标注、模型训练等。</P>
        <h3>4）数据可视化</h3>
        <P>自助式的可视化数据分析展现工具。</P>
        <h3>5）智能检索</h3>
        <P>关键字检索、语义检索、图片检索、全文检索、媒体检索等功能，智能高效。</P>
        <h3>6）智能分析</h3>
        <P class="mb-40">用户行为分析、用户画像、各类业务分析。</P>
        <h2 class="mb-20">系统特色</h2>
        <h3>1）采集及存储</h3>
        <P>支持多种的采集方式，支持非结构数据批量导入自动生成相应的结构化数据。包含分布式文件系统、分布式数据库、关系型数据库、数据调度、分布式计算、数据采集、数据交换、数据转换、数据质量等功能，对海量数据做到便捷、安全存储。</P>
        <h3>2）智能识别</h3>
        <P>对无序纷乱的文件、图片、视频等资源，系统自动识别、分类、标注、监理索引。包含图片智能分类、内容分类、不同维度分类；图片相关性评估，情感倾向评估、搜索内容评估等；图片内容提取、文本内容提取、语音转文字、文章概要生成等功能。</P>
        <h3>3）智能检索</h3>
        <P>支持全文检索、精确检索、语音检索、语义检索、图片检索、媒体检索等功能，系统具有实时高效、关系自动探索、自然语言分析等特点，支持集群管理，查询结果支持丰富的排序策略。</P>
        <h3>4）智能分析</h3>
        <P class="mb-40">系统内置教育行业分析模型，内置个性化行为分析、综合校情分析等多个校园大数据分析场景，按照要求配置相应的数据源既可马上使用。</P>
        <img class="mb-60 m-auto" src="../assets/img/SolutionMuseum/eg-29-01.png" alt />
      </article>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isActive1: 1,
      isActive2: "1-1"
    };
  },
  methods: {
    show(event) {
      let el = event.currentTarget.parentNode;
      console.log(el);
      let flag = (" " + el.className + " ").indexOf(" " + "show" + " ") > -1;
      if (flag) {
        el.classList.remove("show");
      } else {
        el.classList.add("show");
      }
    },
    active(page) {
      this.isActive1 = page.split("-")[0];
      this.isActive2 = page;
      document.getElementById("article").scrollIntoView();
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../assets/scss/_variables.scss";
.other-banner {
  background: url("@/../../assets/img/banner/banner.jpg");
}
article {
  * {
    font-size: 16px;
  }
  flex: 1;
  .m-auto {
    margin-left: auto;
    margin-right: auto;
  }
  .mb-20 {
    margin-bottom: 20px;
  }
  .mb-30 {
    margin-bottom: 30px;
  }
  .mb-40 {
    margin-bottom: 40px;
  }
  .mb-60 {
    margin-bottom: 60px;
  }
  img {
    display: block;
    max-width: 100%;
  }
  h1 {
    font-size: 24px;
    border-left: 4px solid map-get($colors, "primary");
    padding-left: 14px;
    font-weight: bold;
  }
  h2 {
    line-height: 2;
  }
  h3 {
    line-height: 2;
  }
  p {
    line-height: 2;
  }
}
</style>
